import * as React from 'react'
import RequestCtx, { RequestsCtx } from './RequestsCtx'

const Providers = ({
  children,
  ...requestsCtx
}: React.PropsWithChildren & RequestsCtx) => (
  <RequestCtx {...requestsCtx}>{children}</RequestCtx>
)

export default Providers
